import Vue from 'vue'
import App from '@/App'
import router from '@/router'
import store from '@/store'
import { sync } from 'vuex-router-sync'
import VeeValidate from 'vee-validate'
import Debug from 'debug'
import VueSweetAlert from 'vue-sweetalert'
import i18n from '@/lang/lang'
import VueHead from 'vue-head'
import gtagjs from 'vue-gtagjs'
import Vuetify from 'vuetify'
import VueFire from 'vuefire'
import GlobalDirectives from '@/globalDirectives'
import * as Sentry from '@sentry/browser'
import colors from 'vuetify/es5/util/colors'
// import '@fortawesome/fontawesome-free/css/all.css'

const debug = require('debug')('OD::main')

const devMode = process.env.NODE_ENV === 'development'
let environment = ''
if (devMode) {
  Debug.enable('OD::*')
  environment = 'development'
} else {
  Debug.disable()
  environment = 'production'
}

debug('Start')

Sentry.init({
  dsn: 'https://127f2e069b764fa5a557fc074140d08b@sentry.io/1298799',
  environment: environment,
  integrations: [new Sentry.Integrations.Vue({ Vue })],
})

sync(store, router)
Vue.use(VueHead)
Vue.use(VeeValidate)
Vue.use(VueSweetAlert)

Vue.use(Vuetify, {
  iconfont: 'fa',
  theme: {
    primary: colors.blueGrey.darken1,
    secondary: colors.blueGrey.darken4,
    accent: colors.indigo.base,
  },
})
// Vue.use(VueFirestore)
Vue.use(VueFire)

Vue.use(GlobalDirectives)

Vue.config.productionTip = false

Vue.directive('vpshow', {
  inViewport(el) {
    const rect = el.getBoundingClientRect()
    return !(
      rect.bottom < 0 ||
      rect.right < 0 ||
      rect.left > window.innerWidth ||
      rect.top > window.innerHeight
    )
  },

  bind(el, binding) {
    el.classList.add('before-enter')
    el.$onScroll = function() {
      if (binding.def.inViewport(el)) {
        el.classList.add('enter')
        el.classList.remove('before-enter')
        binding.def.unbind(el, binding)
      }
    }
    document.addEventListener('scroll', el.$onScroll)
  },

  inserted(el, binding) {
    el.$onScroll()
  },

  unbind(el, binding) {
    document.removeEventListener('scroll', el.$onScroll)
    delete el.$onScroll
  },
})

// Only active google Analytics if not in Dev Mode
if (!devMode) {
  gtagjs(router, i18n.t('site.gaTrackId'), { debug: devMode, scriptId: 'gtagjs' })
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App),
})
